import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import InputSubmit from "../../common/form/input-submit";
import { useTranslation } from "react-i18next";
import { useProductEditContext } from "../../../routes/catalog/product/edit/product-edit-context";
import useBackNavigation from "../../../hooks/useBackNavigation";

const EditFooter = ({ backLink, backLabel, btnLabel, isLoading, isDisabled = false }) => {
    const { t } = useTranslation();
    const { hideBackLink } = useProductEditContext();
    const handleBackNavigation = useBackNavigation(backLink);

    const shouldShowBack = Boolean(backLink && !hideBackLink);
    const resolvedBackLabel = backLabel ?? t("app.common.back");

    return (
        <div className={"px-4 py-3  bg-solitude-100 text-right sm:px-6 flex items-center justify-between" + (shouldShowBack ? "" : " before:flex-1")}>
            {shouldShowBack && (
                <button
                    type="button"
                    onClick={handleBackNavigation}
                    className="inline-flex cursor-pointer items-center p-4 text-sm underline"
                >
                    <ArrowLeftIcon className="mr-2 h-4 w-4" aria-hidden="true" />
                    {resolvedBackLabel}
                </button>
            )}

            {isDisabled ? (
                <div />
            ) : (
                <InputSubmit isLoading={isLoading} label={btnLabel} />
            )}
        </div>
    );
};

export default EditFooter;
